export class OwnerPropertyResultDto {
    community: string;
    propertyAddress: string;
    isCurrentOwner: boolean;
    communityId: number;
    customerId: string;
}
